import { useState } from 'react';
import dayjs from 'dayjs';

import { OneTimeContributionFormValues } from '../contribution.types';

const currentYear = dayjs().year();

export const useOneTimeContribution = () => {
  const [formValues, setFormValues] = useState<OneTimeContributionFormValues>({});
  const [infoSetup, setInfoSetup] = useState(false);
  const [rollover, setRollover] = useState(false);
  const [taxYear, setTaxYear] = useState(currentYear.toString());

  return {
    formValues,
    setFormValues,
    infoSetup,
    setInfoSetup,
    rollover,
    setRollover,
    currentTaxYear: taxYear,
    setTaxYear,
  };
};
